function handleQueryParameters() {
    var queryStr = window.location.search;

    var paramPairs = queryStr.substr(1).split('&');

    var params = {};

    for (var i = 0; i < paramPairs.length; i++) {
        var parts = paramPairs[i].split('=');
        params[parts[0]] = parts[1];
        // ./beam-designer.html?login=true
        if(parts[0] == 'login' && parts[1] == 'true') {
            openSigninModal();
        }
    }
}

function customerGate() {
    if(customerLevel === "pro") {
        return false;
    }
    if(customerLevel === "basic") {
        openFinishUpgradeModal();
        return true;
    }
    // free or not set
    openSignupModal();
    return true;
}

function setup() {

    gSuppressRedraw = true;

    $( "#I-input" ).change(function(e) { updateIButton(); });

    function configureActiveProjectShapeAndMaterial() {
        activeProject.shape = designConfigurator.shape;
        activeProject.material = designConfigurator.material;
        activeProject.beam.crossSectionRotation = 0;
    }

    function onShapeOrMaterialChanged() {
        configureShapeButton();
        configureMaterialButton();
        configureDesignButton();
        setUnits();
        RedrawCanvas();
        //markBeamDesignNeedsSaved();
        autoBeamFlexureDesign();
    }

    // do this when a north american shape is selected
    $('body').bind('north-american-steel-shape-selected', function(e, shape){
        designConfigurator.northAmericanSteelShape = shape;
        designConfigurator.northAmericanSteelSelected();
        configureActiveProjectShapeAndMaterial();
        onShapeOrMaterialChanged();
        markBeamDesignNeedsSaved();
    });

    // do this when a european shape is selected
    $('body').bind('european-steel-shape-selected', function(e, shape){
        if(customerGate()) { return; }
        designConfigurator.europeanSteelShape = shape;
        designConfigurator.europeanSteelSelected();
        activeProject.design.designType = 'None';
        configureActiveProjectShapeAndMaterial();
        onShapeOrMaterialChanged();
        markBeamDesignNeedsSaved();
    });

    // do this when a wood shape is selected
    $('body').bind('wood-shape-selected', function(e, shape){
        designConfigurator.woodShape = shape;
        designConfigurator.woodSelected();
        configureActiveProjectShapeAndMaterial();
        onShapeOrMaterialChanged();
        markBeamDesignNeedsSaved();
    });

    // do this when an engineered lumber shape is selected
    $('body').bind('engineered-lumber-shape-selected', function(e, shape){
        designConfigurator.engineeredLumberShape = shape;
        designConfigurator.engineeredLumberSelected();
        configureActiveProjectShapeAndMaterial();
        onShapeOrMaterialChanged();
        markBeamDesignNeedsSaved();
    });

    $('body').bind('custom-soldier-shape-selected', function(e, shape){
        if(customerGate()) { return; }
        designConfigurator.customSoldierShape = shape;
        designConfigurator.customSoldierSelected();
        activeProject.design.designType = 'None';
        configureActiveProjectShapeAndMaterial();
        onShapeOrMaterialChanged();
        markBeamDesignNeedsSaved();
    });

    $('body').bind('custom-aluminum-shape-selected', function(e, shape){
        if(customerGate()) { return; }
        designConfigurator.customAluminumShape = shape;
        designConfigurator.customAluminumSelected();
        activeProject.design.designType = 'None';
        configureActiveProjectShapeAndMaterial();
        onShapeOrMaterialChanged();
        markBeamDesignNeedsSaved();
    });

    // do this when a custom shape is selected
    $('body').bind('custom-shape-selected', function(e, shape){
        designConfigurator.customShape = shape;
        designConfigurator.customMaterial = shape;
        designConfigurator.customShapeSelected();
        activeProject.design.designType = 'None';
        activeProject.customShape = shape;
        configureActiveProjectShapeAndMaterial();
        onShapeOrMaterialChanged();
        markBeamDesignNeedsSaved();
    });

    // do this when a custom shape is unselected
    $('body').bind('custom-shape-unselected', function(e){
        if(customerGate()) { return; }
        designConfigurator.northAmericanSteelSelected();
        activeProject.design.designType = 'None';
        configureActiveProjectShapeAndMaterial();
        onShapeOrMaterialChanged();
        markBeamDesignNeedsSaved();
    });

    // do this when a material is selected
    $('body').bind('north-american-steel-material-selected', function(e, material){
        designConfigurator.northAmericanSteelMaterial = material;
        designConfigurator.northAmericanSteelSelected();
        configureActiveProjectShapeAndMaterial();
        onShapeOrMaterialChanged();
        markBeamDesignNeedsSaved();
    });

    $('body').bind('european-steel-material-selected', function(e, material){
        if(customerGate()) { return; }
        designConfigurator.europeanSteelMaterial = material;
        designConfigurator.europeanSteelSelected();
        activeProject.design.designType = 'None';
        configureActiveProjectShapeAndMaterial();
        onShapeOrMaterialChanged();
        markBeamDesignNeedsSaved();
    });

    $('body').bind('wood-material-selected', function(e, material){
        designConfigurator.woodMaterial = material;
        designConfigurator.woodSelected();
        configureActiveProjectShapeAndMaterial();
        onShapeOrMaterialChanged();
        markBeamDesignNeedsSaved();
    });

    $('body').bind('astm-steel-material-selected', function(e, material){
        if(customerGate()) { return; }
        designConfigurator.customSoldierMaterial = material;
        designConfigurator.customSoldierSelected();
        activeProject.design.designType = 'None';
        configureActiveProjectShapeAndMaterial();
        onShapeOrMaterialChanged();
        markBeamDesignNeedsSaved();
    });

    $('body').bind('aluminum-material-selected', function(e, material){
        if(customerGate()) { return; }
        designConfigurator.customAluminumMaterial = material;
        designConfigurator.customAluminumSelected();
        activeProject.design.designType = 'None';
        configureActiveProjectShapeAndMaterial();
        onShapeOrMaterialChanged();
        markBeamDesignNeedsSaved();
    });


    // do this when spans are updated
    $('body').bind('span-table-updated', function(e){
        configureSpanButton();
    });
    // do this when loads are added, deleted or updated
    $('body').bind('load-added-or-updated', function(e){
        configureLoadButton();
        updateLoadTable();
        autoBeamFlexureDesign();
    });
    // do this when load precision has changed
    $('body').bind('load-precision-changed', function(e, decimalPlaces){
        activeProject.loadPrecision = parseInt(decimalPlaces);
        forcePrecisionDecimalPlaces = decimalPlaces;
        momentPrecisionDecimalPlaces = decimalPlaces;
        updateLoadTable();
        RedrawCanvas();
        autoBeamFlexureDesign();
    });
    // do this when bracing has changed
    $('body').bind('bracing-type-changed', function(e){
        configureBracingButton();
        autoBeamFlexureDesign();
    });
    // do this when design changes
    $('body').bind('design-type-changed', function(e){
        configureDesignButton();
        //doBeamFlexureDesign();
    });
    // do this when design deflection limits change
    $('body').bind('design-deflection-limits-changed', function(e){
        //configureDesignButton();
        markBeamDesignNeedsSaved();
        autoBeamFlexureDesign();
    });
    // do this when span length changes
    $('body').bind('span-length-changed', function(e){
      updateLoadTable()
      autoBeamFlexureDesign();
    });
    // do this when calculation starts
    $('body').bind('flexure-design-started', function(e){
      $('#beam-reactions-div').fadeOut('fast');
      $('#beam-results-view-div').fadeOut('fast');
      $('#design-summary-div').fadeOut('fast');
      $('#plots-div').addClass('hidden');
      $('#numerical-results-div').fadeOut('fast');
      $('#results-view-div').fadeOut('fast');
    });
    // do this when calculation ends
    $('body').bind('flexure-design-finished-with-success', function(e){
      $('#beam-reactions-div').fadeIn('fast');
      $('#beam-results-view-div').fadeIn('fast');
      $('#design-summary-div').fadeIn('fast');
      $('#plots-div').fadeIn('fast');
      $('#numerical-results-div').fadeIn('fast');
      $('#results-view-div').fadeIn('fast');
    });
    // do this when calculation ends
    $('body').bind('flexure-design-finished-with-failure', function(e){
      //updateLoadTable()
      //autoBeamFlexureDesign();
    });

    $('body').bind('on-logout-success', function(e) {
        resetActiveProject();
    });

    $('body').bind('on-login-success', function(e){

    });

    // register onclick handlers for our buttons
    $('#add-left-span-button').on('click', function (e) {
      addLeftSpan();
      autoBeamFlexureDesign();
    } );

    $('#add-right-span-button').on('click', function (e) {
      addRightSpan();
      autoBeamFlexureDesign();
    } );

    // set up form validation
    jQuery.validator.setDefaults({
        debug: true,
        success: "valid",
        highlight: function(element) {
            $(element).closest('.form-group').addClass('has-error');
        },
        unhighlight: function(element) {
            $(element).closest('.form-group').removeClass('has-error');
        },
    });

    jQuery.validator.addMethod("validLengthUnit", function(value, element) {
        return !isNaN(wsParseLength(value));
    }, "Please enter a valid length unit. For example <code>5 in</code>, <code>5 inches</code> or <code>5\"</code>");

    jQuery.validator.addMethod("validLocation", function(value, element) {
        var location = wsParseLength(value);
        return (location >= 0 && location <= activeProject.beam.TotalLength());
    }, "Position must be on the beam.");

    initSteelTable();
    initEuropeanSteelTable();
    initASTMSteelTable();
    initAluminumTable();
    initWoodTree();
    initShapeTable();
    initModalSpanDialog();
    initBracingDialog();
    initDesignDialog();

    // configure / initialize tooltips
    $("#show-all-load-cases-tooltip-1").tooltip({ placement: 'right'});
    $("#show-all-load-cases-tooltip-2").tooltip({ placement: 'right'});
    $("#show-all-load-cases-tooltip-3").tooltip({ placement: 'right'});
    $("#load-precision-tooltip").tooltip({ placement: 'right'});

    jQuery(".tm-input").tagsManager({
      backspace: [],
      maxTags: 10,
    });

    jQuery(".tm-input").on('tm:pushed', function(e, tag) {
      activeProject.tags = jQuery(".tm-input").tagsManager('tags');
      markBeamDesignNeedsSaved();
    });

    jQuery(".tm-input").on('tm:spliced', function(e, tag) {
      activeProject.tags = jQuery(".tm-input").tagsManager('tags');
      markBeamDesignNeedsSaved();
    });

    initializeDrawingCanvas();

    initLoadTable();

    initializeStripe();

    initializeFirebaseAuth();

    resetActiveProject();

    initializePrintPreferencesDialog();

    initializeProjectHeaderSettingsDialog();

    handleQueryParameters();

    gSuppressRedraw = false;
    RedrawCanvas();

    window.addEventListener("beforeunload", function (e) {
        if (activeProject.isModified === false) {
            return undefined;
        }

        var confirmationMessage = 'Your project needs to be saved. '
                                + 'If you leave before saving, your changes will be lost.';

        (e || window.event).returnValue = confirmationMessage; //Gecko + IE
        return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
    });

}
